$(document).ready(function() {
  if (location.pathname === '/cart') {
    $('.cart__dynamic-checkout-buttons').hide() 

    function validateCartItems() {
      $.getJSON('/cart.js', function(cart) {
        // var cartHasCookies = false
        // var cookiesCount = 0
        var cartTotal = cart.total_price / 100
        
        $($('.shipping-method-tybo')[0].options[1]).prop('disabled', false)
  
        /*$(cart.items).each(function() {
          if (this.product_type == 'NY Style Cookies') {
            cookiesCount += this.quantity 
            cartHasCookies = true
          }
        })*/
        
        if (cartTotal < 35) {
          $('.custom-cart-qty-msg').show()
        }

        if (cartTotal > 35) {    
          // $('.cart__dynamic-checkout-buttons').show()
        }
      })
    }

    validateCartItems()
    
    $('.btn-cart-remove-item').click(function() { 
      $('.custom-tybo-checkout').prop('disabled', true)
      $('.custom-cart-qty-msg').hide()
      $('.cart__dynamic-checkout-buttons').hide()
      setTimeout(function () { 
        validateCartItems()
        $('.custom-tybo-checkout').prop('disabled', false)
      }, 2000);
    })

    $('body').on('click', '.quantity__button', function() {  
      $('.custom-tybo-checkout').prop('disabled', true)
      $('.custom-cart-qty-msg').hide()
      $('.cart__dynamic-checkout-buttons').hide()
      setTimeout(function () { 
        validateCartItems()
        $('.custom-tybo-checkout').prop('disabled', false)
      }, 2000);
    }) 

    var today = new Date()
    var minDate = 0
    
    $("#tybo-shipping-date").datepicker({
      minDate: 4,    
      maxDate: 7, 
      stepMonths: 1,
      beforeShowDay: function(date) {
        var day = date.getDay();
        return [day === 5, ''];
      }, 
      onSelect: function(date) {
        var timePicker = $('.pickup-time-tybo')[0]
        $('shipping-terms').hide()
        $('.tybo-shipping-terms').hide()
        $('.tybo-diff-location').hide()  
        
        if ($('.shipping-method-tybo').val() == 'Pickup') {
          for (var key in Object.keys(timePicker.options)) {
            if (key > 0) {
              $(timePicker.options[key]).prop('disabled', false)
            }
          } 
          
          $('.pickup-time-tybo').prop('disabled', false) 
  
          var d = new Date();
  
          var today = d.toLocaleDateString("en-US", { 
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }) 
          
          if (date == '06/17/2023') { 
            $(timePicker.options[1]).prop('disabled', true)
            $(timePicker.options[2]).prop('disabled', true)
            $(timePicker.options[3]).prop('disabled', true)
            $(timePicker.options[4]).prop('disabled', true)
          } else if (date == '11/23/2023') { 
            $(timePicker.options[5]).prop('disabled', true)
            $(timePicker.options[6]).prop('disabled', true)
            $(timePicker.options[7]).prop('disabled', true)
            $(timePicker.options[8]).prop('disabled', true)
            $(timePicker.options[9]).prop('disabled', true)
            $(timePicker.options[10]).prop('disabled', true)
          } else { 
            $(timePicker.options[1]).prop('disabled', true)
            $(timePicker.options[2]).prop('disabled', true)
            $(timePicker.options[3]).prop('disabled', true)
          } 
  
          if (today == date) {  
            var currentHour = d.getHours();
  
            for (var key in Object.keys(timePicker.options)) {
              if (key > 0) {
                var hour = $(timePicker.options[key]).data('hour')
    
                if (currentHour >= hour) {
                  $(timePicker.options[key]).prop('disabled', true)
                  $(timePicker.options[parseInt(key) + 1]).prop('disabled', true)   
                }
              }
            }
          }
        }
      } 
    })
  
    $('.shipping-method-tybo').on('change', function() {
      $('.tybo-date-input').val('')

      if ($(this).val().length) {
        $('.tybo-date-input').prop('disabled', false)
        $('.tybo-date-input').prop('readonly', true)
      } else {
        $('.tybo-date-input').prop('disabled', true)
        $('.tybo-date-input').prop('readonly', false)
      }

      var today = new Date()

      $('#tybo-shipping-date').prop('disabled', false) 
      $('#tybo-shipping-date').prop('readonly', true) 
      
      if ($(this).val() == 'Pickup') {              
        $('.pickup-time-tybo-cont').show()
        $('.shipping-terms').hide()
        $('.tybo-shipping-terms').hide()
      } else {
        $('.pickup-time-tybo-cont').hide() 
        $('.shipping-terms').show()
      }
    })
  
    $('.custom-tybo-checkout').click(function() {
      $('.tybo-qty-validation').hide() 
      $('.tybo-shipping-validation').hide()
      $('.tybo-pickup-time-validation').hide()
      var shippingMethod = $('.shipping-method-tybo').val()
      var shippingDate = $('.tybo-date-input').val() ? $('.tybo-date-input').val() : false   
      var pickupTime = $('.pickup-time-tybo').val()

      $.getJSON('/cart.js', function(cart) {
        var cartHasCookies = false
        var cookiesCount = 0
        var cartTotal = cart.total_price / 100

        /*$(cart.items).each(function() {
          if (this.product_type == 'NY Style Cookies') { 
            cookiesCount += this.quantity
            cartHasCookies = true
          }
        })*/ 
        
        if (cartTotal < 35) { 
          $('.tybo-qty-validation').show() 
        } else {
          if (!shippingMethod.length || !shippingDate.length) { 
            $('.tybo-shipping-validation').show()
          } else if (shippingMethod == 'Pickup' && !pickupTime.length) {
            $('.tybo-pickup-time-validation').show() 
          } else if ($('.shipping-method-tybo').val() == 'Shipping' && !$("#agree-shipping").is(":checked")) {
            $('.tybo-shipping-terms').show()
          } else {  
            var attributes = {}
      
            attributes['Shipping Method'] = shippingMethod
      
            if (shippingMethod == 'Pickup') {
              attributes['Pickup Date'] = shippingDate
              attributes['Pickup Time'] = pickupTime
              attributes['Shipping Date'] = null
            } else {
              attributes['Shipping Date'] = shippingDate
              attributes['Pickup Date'] = null
              attributes['Pickup Time'] = null
            } 
            
            $.ajax({ 
              type: 'POST',
              url: '/cart/update.js',
              data: {
                'attributes': attributes 
              },
              dataType: 'json',
              success: function() {  
                $('.cart__checkout-button').click()
              } 
            })       
          }
        }
      }) 
    })
  }

  function loadNextFriday() {
    var select = $('#tybo-shipping-date');
    select.empty();

    var today = new Date();
    var nextFriday = new Date(today);
    
    if (today.getDay() === 5 && today.getHours() >= 15) { 
      nextFriday.setDate(today.getDate() + 7);
    } else if (today.getDay() === 1) { 
      nextFriday.setDate(today.getDate() + 7); 
    } else {
      var daysUntilNextFriday = (1 - today.getDay() + 7) % 7;
      nextFriday.setDate(today.getDate() + daysUntilNextFriday);
    } 

    // Ajuste de la hora a 15:00 (3 p.m.)
    nextFriday.setHours(15);
    nextFriday.setMinutes(0);
    nextFriday.setSeconds(0);

    var formattedDate = nextFriday.toISOString().slice(0, 10);
    
    select.append($('<option>', {
        value: formattedDate,
        text: formattedDate
    })); 

    /*select.append($('<option>', {
        value: '2025-01-13',
        text: '2025-01-13'
    }));*/
  }  

  loadNextFriday(); 

  $('#tybo-shipping-date').change(function() {
    var selectedDate = $(this).val();
    var shippingMethod = $('.shipping-method-tybo').val();

    if (shippingMethod == 'Pickup') {
      if (selectedDate) {
        $('.pickup-time-tybo').prop('disabled', false);
      } else {
        $('.pickup-time-tybo').prop('disabled', true);
      }
    }
  });

  // Eliminar opciones de 9 AM, 10 AM y 11 AM del selector
  var pickupTimeOptions = document.querySelectorAll('.pickup-time-tybo option');

  pickupTimeOptions.forEach(function(option) {
    var hour = parseInt(option.value);
    if (hour >= 9 && hour <= 11) {
      option.remove();
    }
  });
});
